<template>
  <div id="app">
    <GlobalHeader v-if="showHeader" />
    <main :class="['app-main', { 'with-header': showHeader }]">
      <router-view />
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalHeader from './components/GlobalHeader.vue'

export default {
  name: 'App',
  
  components: {
    GlobalHeader
  },
  
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    
    showHeader() {
      const noHeaderRoutes = ['/login', '/accept-invite']
      const currentPath = this.$route.path
      return this.isAuthenticated && !noHeaderRoutes.some(r => currentPath.startsWith(r))
    }
  }
}
</script>

<style>
.app-main {
  min-height: 100vh;
}

.app-main.with-header {
  padding-top: 74px;
}
</style>
